import React, { Component } from 'react';
import { Col } from 'react-bootstrap';

import ContactForm from '../components/contact/ContactForm';
import BlockWrapper from '../components/blocks/BlockWrapper';
import IconBlock from '../components/blocks/IconBlock';
import GenericBlock from '../components/blocks/GenericBlock';
import Slider from '../components/Slider';
import QuoteBar from '../components/QuoteBar';

import backgroundImage from '../resources/img/slider-bg-pic5.jpg';

class Contact extends Component {

    render() {
        document.title = 'TROI Studio | Contact';

        var textLeft = (
            <h2>
                TROI is based in Amsterdam,<br />
                a creative hub with 6,000 media professionals <br />
                from 180 different nationalities.<br />
                Our company is your gateway to all that talent!
            </h2>
        );


        var textRight = (
            <span>Contact</span>
        );

        // We need the below code to obfuscate the email address for spambots
        var obfuscatedEmail = (
            <a href='mailt&#111;&#58;inf&#111;&#64;t&#114;o&#105;%&#55;3tu&#100;&#37;&#54;9%&#54;F%2E&#37;&#54;3&#37;6Fm'>inf&#111;&#64;troistudio&#46;com</a>
        );

        var textBox = (
            <GenericBlock>
                <Col md={6}>
                    <h4>Contact information</h4>

                    <p>
                        <strong>Email:</strong> {obfuscatedEmail}<br />
                    </p>

                    <h4>Contact Form</h4>

                    <ContactForm />
                </Col>
            </GenericBlock>
        );

        return (
            <div>
                <Slider backgroundImage={backgroundImage}
                    textLeft={textLeft} textRight={textRight} />
                <QuoteBar text="" />

                <BlockWrapper>
                    <IconBlock className="hidden-xs hidden-sm" icon="envelope">
                        <h3>Contact</h3>
                    </IconBlock>

                    {textBox}
                </BlockWrapper>
            </div>
       );
    }

}

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact.js